import { PostTypes } from './constants/postTypes'

export const computeNewUpscore = (upscore, post) => {
  if (!upscore) {
    // eslint-disable-next-line no-param-reassign
    upscore = {
      total: 0,
      workout: 0,
      sport: 0,
      recovery: 0,
      mindfulness: 0,
    }
  }

  let newWorkoutUpscore = upscore.workout ?? 0
  let newSportUpscore = upscore.sport ?? 0
  let newRecoveryUpscore = upscore.recovery ?? 0
  let newMindfulnessUpscore = upscore.mindfulness ?? 0

  if (
    post.type === PostTypes.WORKOUT ||
    (post.type === PostTypes.ACTIVITY && post.activityGroup === 'workout')
  ) {
    newWorkoutUpscore += 1
  } else if (post.type === PostTypes.ACTIVITY && post.activityGroup === 'sport') {
    newSportUpscore += 1
  } else if (post.type === PostTypes.ACTIVITY && post.activityGroup === 'recovery') {
    newRecoveryUpscore += 1
  } else if (post.type === PostTypes.ACTIVITY && post.activityGroup === 'mindfulness') {
    newMindfulnessUpscore += 1
  }

  return {
    total: newWorkoutUpscore + newSportUpscore + newRecoveryUpscore + newMindfulnessUpscore,
    workout: newWorkoutUpscore,
    sport: newSportUpscore,
    recovery: newRecoveryUpscore,
    mindfulness: newMindfulnessUpscore,
  }
}
